<section class=" bg-dark-blue relative overflow-hidden" aria-labelledby="song-hub-heading">
  <!-- Background decorative elements -->
  <div class="absolute inset-0 overflow-hidden opacity-10">
    <div class="absolute w-full h-full">
      <!-- Musical note-inspired patterns -->
      <div class="absolute top-20 left-[10%] w-16 h-48 border-l-2 border-t-2 border-white/30 rounded-tl-3xl"></div>
      <div class="absolute top-40 left-[20%] w-16 h-32 border-r-2 border-b-2 border-white/20 rounded-br-3xl"></div>
      <div class="absolute bottom-20 right-[15%] w-24 h-24 border-2 border-white/20 rounded-full"></div>
      <div class="absolute top-[30%] right-[25%] w-12 h-12 border-2 border-white/30 rounded-full"></div>
    </div>
  </div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <!-- Section header -->
    <div class="text-center mb-4 lg:mb-16" data-aos="fade-up">
      <h2 id="song-hub-heading" class="section-title">Your comprehensive music solution</h2>
      <p class="text-lg text-white/70 max-w-3xl mx-auto mt-4">
        We offer a complete ecosystem of music integration options tailored to your specific needs.
      </p>
    </div>

    <!-- Three feature blocks -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-12">
      <!-- Block 1: All Inclusive -->
      <article class="feature-block" data-aos="fade-up" data-aos-delay="0">
        <div class="mb-6 relative">
          <!-- Visual element with hover effect -->
          <div
              class="aspect-video bg-gradient-to-br from-charcoal to-dark-gray rounded-xl overflow-hidden relative group shadow-glow-sm hover:shadow-glow transition-all duration-500">
            <div
                class="absolute inset-0 bg-gradient-to-br from-why-us-purple/20 to-why-us-magenta/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <svg class="h-12 w-12 text-why-us-purple" fill="none" stroke="currentColor"
                   viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                    stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5"/>
              </svg>
            </div>
          </div>
        </div>

        <h3 class="text-xl md:text-2xl font-bold text-white mb-3">All Inclusive</h3>
        <p class="text-white/70 mb-4">
          Recommendations can include your favorite artists and songs for personal use on relevant platforms (social,
          video, etc.)
        </p>

        <ul class="space-y-2 mb-5">
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-purple mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Access to millions of tracks</span>
          </li>
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-purple mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Personalized recommendations</span>
          </li>
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-purple mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Perfect for personal content</span>
          </li>
        </ul>
      </article>

      <!-- Block 2: Licensable Music Options -->
      <article class="feature-block" data-aos="fade-up" data-aos-delay="100">
        <div class="mb-6 relative">
          <!-- Visual element with hover effect -->
          <div
              class="aspect-video bg-gradient-to-br from-charcoal to-dark-gray rounded-xl overflow-hidden relative group shadow-glow-sm hover:shadow-glow transition-all duration-500">
            <div
                class="absolute inset-0 bg-gradient-to-br from-why-us-magenta/20 to-why-us-lavender/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <svg class="h-12 w-12 text-why-us-magenta" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"
                    stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5"/>
              </svg>
            </div>
          </div>
        </div>

        <h3 class="text-xl md:text-2xl font-bold text-white mb-3">Licensable Music Options</h3>
        <p class="text-white/70 mb-4">
          Out of the box partnerships with music providers and rightsholders for commercial use.
        </p>

        <ul class="space-y-2 mb-5">
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-magenta mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Ready-to-use music partnerships</span>
          </li>
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-magenta mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Commercial licensing available</span>
          </li>
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-magenta mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Rights management included</span>
          </li>
        </ul>
      </article>

      <!-- Block 3: Tailored Catalog Support -->
      <article class="feature-block" data-aos="fade-up" data-aos-delay="200">
        <div class="mb-6 relative">
          <!-- Visual element with hover effect -->
          <div
              class="aspect-video bg-gradient-to-br from-charcoal to-dark-gray rounded-xl overflow-hidden relative group shadow-glow-sm hover:shadow-glow transition-all duration-500">
            <div
                class="absolute inset-0 bg-gradient-to-br from-why-us-lavender/20 to-why-us-blue/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <svg class="h-12 w-12 text-why-us-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                    stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5"/>
              </svg>
            </div>
          </div>
        </div>

        <h3 class="text-xl md:text-2xl font-bold text-white mb-3">Tailored Catalog Support</h3>
        <p class="text-white/70 mb-4">
          Add any catalog or music collection, accommodating specific business use-cases.
        </p>

        <ul class="space-y-2 mb-5">
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-blue mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Custom catalog integration</span>
          </li>
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-blue mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Business-specific use cases</span>
          </li>
          <li class="flex items-start">
            <svg class="h-5 w-5 text-why-us-blue mr-2 mt-0.5 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <span class="text-sm text-white/80">Flexible collection management</span>
          </li>
        </ul>
      </article>
    </div>

    <!-- CTA button -->
    <div class="mt-12 text-center" data-aos="fade-up">
      <a class="btn btn-accent inline-flex items-center gap-2" href="#pricing">
        Explore Pricing Options
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 5l7 7m0 0l-7 7m7-7H3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>
      </a>
    </div>
  </div>
</section>
